import Posts, { IPosts } from '@/models/Posts'

import config from '@/config'
import BaseService from './BaseService'
import { requests } from './HTTPService'

const http = requests(config?.COMMUNITIES_SERVER_URL)
export default class PostsService extends BaseService<Posts> {
  protected subdomain = ''
  readonly groupId: string

  model(): typeof Posts {
    return Posts
  }

  constructor(locationId: string, groupId: string) {
    super(locationId)
    this.groupId = groupId
    this.basePath = `/${locationId}/groups/${groupId}`
  }

  create(data: { [key: string]: any }): Promise<any> {
    return http
      .post(`${this.endpoint}/channels/${data.channelId}/posts`, data)
      .then((res: any) => {
        return res.data
      })
  }

  async getPublicPosts(query?: any): Promise<any> {
    const response = await http.get(`${this.endpoint}/public/posts`, {
      params: query,
    })
    return response.data
  }

  async getPost(postId: string): Promise<any> {
    const response = await http.get(`${this.endpoint}/posts/${postId}`)
    return response.data
  }

  async getChannelPosts(channelId: string, query?: any): Promise<any> {
    const response = await http.get(
      `${this.endpoint}/channels/${channelId}/posts`,
      { params: query }
    )
    return response.data
  }

  async pinPostToChannel(postId: string, channelId: string): Promise<any> {
    const response = await http.patch(
      `${this.endpoint}/channels/${channelId}/posts/${postId}`,
      {
        action: 'PIN_TO_CHANNEL',
      }
    )
    return response.data
  }

  async pinPostToHome(postId: string, channelId: string): Promise<any> {
    const response = await http.patch(
      `${this.endpoint}/channels/${channelId}/posts/${postId}`,
      {
        action: 'PIN_TO_HOME',
      }
    )
    return response.data
  }

  async unpinPostFromChannel(postId: string, channelId: string): Promise<any> {
    const response = await http.patch(
      `${this.endpoint}/channels/${channelId}/posts/${postId}`,
      {
        action: 'UNPIN_FROM_CHANNEL',
      }
    )
    return response.data
  }

  async unpinPostFromHome(postId: string, channelId: string): Promise<any> {
    const response = await http.patch(
      `${this.endpoint}/channels/${channelId}/posts/${postId}`,
      {
        action: 'UNPIN_FROM_HOME',
      }
    )
    return response.data
  }

  async getChannelPinnedPosts(
    channelId: string,
    paginationParams: any
  ): Promise<any> {
    const response = await http.get(
      `${this.endpoint}/channels/${channelId}/posts/pinned`,
      { params: paginationParams }
    )
    return response.data
  }

  async getHomePinnedPosts(paginationParams: any): Promise<any> {
    const response = await http.get(`${this.endpoint}/posts/pinned`, {
      params: paginationParams,
    })
    return response.data
  }

  async updatePostChannel(postId: string, channelId: string): Promise<any> {
    const response = await http.post(
      `${this.endpoint}/posts/${postId}/update-channel`,
      {
        channelId,
      }
    )
    return response.data
  }

  async getUserHomeTimeline(userId: string): Promise<any> {
    const response = await http.get(`${this.endpoint}/${userId}/home-timeline`)
    return response.data
  }

  async updatePost(
    postData: IPosts,
    channelId: string,
    postId: string
  ): Promise<any> {
    const response = await http.patch(
      `${this.endpoint}/channels/${channelId}/posts/${postId}`,
      {
        action: 'UPDATE_POST',
        post: postData,
      }
    )
    return response.data
  }

  async getPostsByUser(params: any): Promise<any> {
    return http.get(`${this.endpoint}/posts`, { params }).then(res => res.data)
  }

  async deletePost(postId: string): Promise<any> {
    return http
      .delete(`${this.endpoint}/posts/${[postId]}`)
      .then(res => res.data)
  }
}
